import React from 'react';
import { Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { DialogBox } from '../../common/components/DialogBox';
import { BasicRRMessageStyles } from '../styles/BasicRRMessage';
import { RRMessageProps } from './layout_01/BasicTaskListLayout';
import HtmlParser from 'react-html-parser';
import { ReactComponent as ResponseReuseIcon } from '../images/response_reuse.svg';

const RRMessagePopup = (props: RRMessageProps): JSX.Element => {
  const classes = BasicRRMessageStyles();
  const { onRRMsgBtnClick, showRRPopup } = props;
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.down('sm'));
  if (!showRRPopup) return <></>;

  return (
    <DialogBox buttonText={props.buttonText || ''} onSubmit={(): void => onRRMsgBtnClick && onRRMsgBtnClick(false)}>
      {smUp && <ResponseReuseIcon />}
      <Typography color="inherit" variant="h3" align="center" className={classes.title}>
        {props.title}
      </Typography>
      <Typography color="inherit" align="center" className={classes.content}>
        {props.subtitle1}
        <br />
        {props.subtitle2}
      </Typography>
      <Typography color="inherit" align="center" className={`${classes.content} ${classes.marginBottom}`}>
        {props.subtitle3}
        <br />
        {HtmlParser(props.subtitle4)}
      </Typography>
    </DialogBox>
  );
};

export default RRMessagePopup;
